"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import { workScopeStatusOptions } from "../../constants/options"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import WorkScopeStatusSelect from "../work-scope-status-select"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"
import FormTextareaInput from "../../../../shared/components/form-inputs/form-textarea-input"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const BASE_FIELD_NAME = "home.moldRemediationInfo"

function HomeMoldRemediationForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillMoldRemediationOn = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillMoldRemediationOn` })
    
    // Watch status field and claimed by field
    const moldRemediation = useWatch({ control, name: `${BASE_FIELD_NAME}.moldRemediation` })
    const claimedBy = useWatch({ control, name: `${BASE_FIELD_NAME}.claimedBy` })
    const goodwillMoldRemediation = useWatch({ control, name: `${BASE_FIELD_NAME}.goodwillMoldRemediation` })
    const goodwillMoldRemediationClaimedBy = useWatch({
        control,
        name: `${BASE_FIELD_NAME}.goodwillMoldRemediationClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: moldRemediation,
        claimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.claimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillMoldRemediation,
        claimedBy: goodwillMoldRemediationClaimedBy,
        claimedByFieldPath: `${BASE_FIELD_NAME}.goodwillMoldRemediationClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillMoldRemediationOn,
    })

    return (
        <HomeDetailsWrapperAccordion heading="Mold Remediation" wrapperClassName="two-cols-grid">
            <WorkScopeStatusSelect workScopeSlug="mold-remediation"
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Mold Remediation" toggleName={`${BASE_FIELD_NAME}.goodwillMoldRemediationOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${BASE_FIELD_NAME}.moldRemediation`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Claimed By",
                }}
                options={claimedByOptions}
                name={`${BASE_FIELD_NAME}.claimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillMoldRemediationOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Mold Remediation Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${BASE_FIELD_NAME}.goodwillMoldRemediation`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Mold Remediation Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${BASE_FIELD_NAME}.goodwillMoldRemediationClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <FormTextInput
                inputGroupProps={{
                    label: "What is the highest moisture level measured in the walls by a moisture meter?",
                }}
                placeholder="What is the highest moisture level measured in the walls by a moisture meter?"
                name={`${BASE_FIELD_NAME}.highestMoistureLevel`}
                type="number"
                control={control}
            />
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{ label: "Give a brief description of the mold remediation status what remains to be done", wrapperClassName: "two-cols" }}
                rows={4}
                name={`${BASE_FIELD_NAME}.description`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeMoldRemediationForm
